import React from "react";

const ContactSection = () => {
  return (


<>



    <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title">Contact us</h2>
           
          </div>
        </div>
      </div>
    </div>



    <section className="contact-section">
      <div className="container">
        {/* Contact Info */}
        <div className="contact-info-area">
          <div className="row">
            <div
              className="col-lg-4 col-md-6 col-12 d-flex "
              data-aos="fade-down"
              data-aos-duration="1200"
              data-aos-delay="0.1"
            >
              <div className="single-contact-info flex-fill borderrr">
                <span>
                  <i className="feather-phone-call"></i>
                </span>
                <h3>Phone Number</h3>
                <a href="tel:919011955415">+91  9011955415</a>
              </div>
            </div>

            <div
              className="col-lg-4 col-md-6 col-12 d-flex " 
              data-aos="fade-down"
              data-aos-duration="1200"
              data-aos-delay="0.2"
            >
              <div className="single-contact-info flex-fill borderrr">
                <span>
                  <i className="feather-mail"></i>
                </span>
                <h3>Email Address</h3>
                <a href="mailto:booking@srscabservice.com">booking@srscabservice.com</a>
              </div>
            </div>

            <div
              className="col-lg-4 col-md-6 col-12 d-flex"
              data-aos="fade-down"
              data-aos-duration="1200"
              data-aos-delay="0.3"
            >
              <div className="single-contact-info flex-fill borderrr">
                <span>
                  <i className="feather-map-pin"></i>
                </span>
                <h3>Location</h3>
                <a href="javascript:void(0);">Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027</a>
              </div>
            </div>

    
          </div>
        </div>

        {/* Contact Form */}
<iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2713.1265851410503!2d73.77091777519333!3d18.590460082516735!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTjCsDM1JzI1LjciTiA3M8KwNDYnMjQuNiJF!5e1!3m2!1sen!2sin!4v1774268184715!5m2!1sen!2sin" width="100%" height="450"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
      </div>
    </section>

</>
  );
};

export default ContactSection;